import store from "@/store";
import tagService from '@/features/Tags/services/baseTag.service';
import { error as debugError } from '@/utils/debugLogger';

export const GlobalSearch = {
	state: {
		selectedItem: null,
		showDocumentsView: false,
		globalSearchText: "",
		isolatedTypes: [],
		globalSearchResult: [],
		isolatedTagsInfo: null,
		advancedSearch: {
			searchRows: [],
			searchLinkedTags: true,
			searchDocuments: false,
		}
	},
	mutations: {
		SET_SELECTED_ITEM(state, value) {
			state.selectedItem = value;
		},
		SET_SHOW_DOCUMENTS_SECTION(state, value) {
			state.showDocumentsView = value;
		},
		SET_GLOBAL_SEARCH_TEXT(state, value) {
			state.globalSearchText = value ?? '';
			if (!value) {
				store.commit('SET_ISOLATED_TAGS_INFO', null);
			}
		},
		SET_GLOBAL_SEARCH_RESULT(state, value) {
			state.globalSearchResult = value ?? [];
		},
		ADD_GLOBAL_SEARCH_RESULT_ITEMS(state, { type, items, total }) {
			// Find the group with the matching type
			const groupIndex = state.globalSearchResult.findIndex(group => group.type === type.toLowerCase());

			if (groupIndex !== -1) {
				// Group exists, append items and update total
				const existingItems = state.globalSearchResult[groupIndex].items || [];
				const uniqueItems = items.filter(item =>
					!existingItems.some(existing => existing.id === item.id)
				);

				state.globalSearchResult[groupIndex].items = [...existingItems, ...uniqueItems];

				if (total !== undefined) {
					state.globalSearchResult[groupIndex].total = total;
				}
			} else if (items.length > 0) {
				// Group doesn't exist but we have items, create a new group
				state.globalSearchResult.push({
					type: type.toLowerCase(),
					items: items,
					total: total
				});
			}
		},
		SET_ISOLATED_TYPES: (state, value) => {
			state.isolatedTypes = value;
		},
		SET_ADVANCED_SEARCH(state, value) {
			state.advancedSearch = value;
		},
		SET_ISOLATED_TAGS_INFO(state, value) {
			state.isolatedTagsInfo = value;
			store.state.forgeService.update3dIconsInAllViews();
		},
	},
	actions: {
		GLOBAL_SEARCH_ISOLATE({ commit }, { payload, signal }) {
			return new Promise((resolve, reject) => {
				tagService.isolate(payload, signal).then(({ data }) => {
					commit('SET_ISOLATED_TAGS_INFO', {
						tagsIds: new Set(data.tagsIds),
						dbIds: data.dbIds
					});
					store.state.forgeService?.getMainExtension()?.isolateDbIds(data.dbIds);
					resolve(data);
				}).catch(error => {
					debugError(error);
					reject(error);
				});
			});
		},
	},
	getters: {
		GET_ISOLATED_IDS(state) {
			return state.isolatedTagsInfo?.tagsIds ?? new Set();
		},
		GET_ISOLATED_DBIDS(state) {
			return state.isolatedTagsInfo?.dbIds ?? [];
		},
		GET_SELECTED_ITEM(state) {
			return state.selectedItem;
		},
		GET_SHOW_DOCUMENTS_SECTION(state) {
			return state.showDocumentsView;
		},
		GET_GLOBAL_SEARCH_RESULT(state) {
			return state.globalSearchResult;
		},
		GET_GLOBAL_SEARCH_TEXT(state) {
			return state.globalSearchText;
		},
		GET_ISOLATED_TYPES: (state) => {
			return state.isolatedTypes;
		},
		ADVANCED_SEARCH(state) {
			return state.advancedSearch;
		},
	},
}